"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Environment = /** @class */ (function () {
    function Environment(opts) {
        this._transportsManager = opts.transportsManager;
        this._network = opts.network;
    }
    Object.defineProperty(Environment.prototype, "network", {
        get: function () {
            return this._network;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Environment.prototype, "transportsManager", {
        get: function () {
            return this._transportsManager;
        },
        enumerable: false,
        configurable: true
    });
    return Environment;
}());
exports.default = Environment;
//# sourceMappingURL=environment.js.map